export const textButtonProps = {
  fontWeight: "bold",
  color: "action",
  variant: "body",
};
